import { Label } from "@tandemdiabetes/sugarmate-react-components"
import { FollowerInvite } from "./FollowerInvite"
import styles from "./Sharing.module.scss"
import { usePolyglot } from "src/contexts"
import { useFollowInvites } from "src/hooks"

const polyglotPrefix = "pages.data_sharing.share_my_data.sent_invitations."

export function FollowerInvitesList() {
  const polyglot = usePolyglot()
  const { data: followInvites } = useFollowInvites()

  return (
    <div
      className={styles.list}
      id="sent-invitations-list"
    >
      <Label className={styles.sectionLabel}>
        {polyglot.t(`${polyglotPrefix}label`)}
      </Label>
      {followInvites?.map((followInvite) => (
        <FollowerInvite
          key={followInvite.id}
          followInvite={followInvite}
        />
      ))}
    </div>
  )
}
